import React, { useEffect, useContext, useState } from 'react'
import ReactGA from 'react-ga'
import { Redirect, Route, useHistory } from 'react-router-dom'

import { RootContext } from '../../context/rootContext'
import { getProfessionalCategory } from '../../utils/constants'
import { ReactComponent as UserIcon } from '../../assets/icons/user-header.svg'
import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar-alt.svg'
import { ReactComponent as ChartSimpleIcon } from '../../assets/icons/chart-simple.svg'
import { ReactComponent as CommentsIcon } from '../../assets/icons/comments-alt.svg'
import { ReactComponent as BellIcon } from '../../assets/icons/bell.svg'
import Footer from '../Footer/index'

import {
  ProfileHeader,
  ProfileInfo,
  ProfileName,
  ProfileCnpj,
  ButtonLogout,
  ProfileTab,
  ProfileTabItem,
  TabName,
  NotificationsCount
} from './styles'

const PrivateRoute = ({ children, ...rest }) => {
  const { globalState, handleUpdateUserData } = useContext(RootContext)
  const [state] = globalState
  const [solicitationsCount, setSolicitationsCount] = useState(0)
  const [notificationsCount, setNotificationsCount] = useState(0)
  const isLogged = !!localStorage.getItem('userData')
  const { professional, partner } =
    isLogged && JSON.parse(localStorage.getItem('userData'))
  const professionalId = professional?.id
  const partnerId = partner
  const history = useHistory()

  useEffect(() => {
    const solicitations = state.solicitationsList.filter(solicitation => (solicitation.answerMessage && !solicitation.answerRead)).length
    const notifications = state.notificationsList
    const countNotifications = notifications.filter(notification => {
      const partnerData = notification?.partners.find(partner => partner.partner === partnerId && partner.professionals)
      const professionalData = partnerData?.professionals.find(prof => prof.professional === professionalId)
      return !professionalData?.read
    })
    setSolicitationsCount(solicitations)
    setNotificationsCount(countNotifications.length)
  }, [state, partnerId, professionalId])

  const handleLogout = () => {
    document.body.style.removeProperty('margin-bottom')
    localStorage.removeItem('userData')
    handleUpdateUserData(JSON.parse(localStorage.getItem('userData')))
    history.push('/login')
    ReactGA.pageview('/login')
  }

  const handleCalendarClick = () => {
    history.push('/daily')
    ReactGA.pageview('/daily')
  }

  const handleSolicitationsClick = () => {
    history.push('/solicitations')
    ReactGA.pageview('/solicitations')
  }

  const handleDashboardClick = () => {
    history.push('/dashboard')
    ReactGA.pageview('/dashboard')
  }

  const handleNotificationsClick = () => {
    history.push('/notifications')
    ReactGA.pageview('/notifications')
  }

  const isActive = pages => {
    const locationPath = (window.location && window.location.pathname)
      ? window.location.pathname
      : '/daily'

    const regexRoutes = pages.map(page => new RegExp(`^${page.replace(/:[^/]+/g, '[^/]+')}$`))
    return regexRoutes.some(regex => regex.test(locationPath))
      ? 'active'
      : ''
  }

  // Define a aba ativa para cada rota
  const routesPath = {
    calendar: [
      '/',
      '/daily',
      '/monthly'
    ],
    solicitations: [
      '/solicitations-history',
      '/solicitations',
      '/new-agenda-block',
      '/new-scheduling'
    ],
    dashboard: [
      '/dashboard',
      '/dashboard/scheduling-details',
      '/dashboard/scheduling-details/status',
      '/dashboard/scheduling-details/daily',
      '/dashboard/billing',
      '/dashboard/billing/daily',
      '/dashboard/services',
      '/dashboard/services/clients'
    ],
    notifications: [
      '/notifications',
      '/notification-details/:id'
    ]
  }

  const isFreelance = getProfessionalCategory() === 'FREELANCE'
  const isFranchising = getProfessionalCategory() === 'FRANCHISING'
  const hasMainProfessionalFranchising = professional?.mainProfessional?.category === 'FRANCHISING'
  const showNotificationTab = isFranchising || (isFreelance && hasMainProfessionalFranchising)

  return (
    <>
      {isLogged && (
        <>
          <ProfileHeader>
            <UserIcon />
            <ProfileInfo>
              <ProfileName>{professional.name}</ProfileName>
              <ProfileCnpj>CNPJ {professional.cnpj}</ProfileCnpj>
            </ProfileInfo>
            <ButtonLogout onClick={handleLogout} id='logout-button'>sair</ButtonLogout>
          </ProfileHeader>
          <ProfileTab>
            <ProfileTabItem onClick={handleCalendarClick} className={isActive(routesPath.calendar)}>
              <CalendarIcon />
              <TabName>Calendário</TabName>
            </ProfileTabItem>
            <ProfileTabItem onClick={handleSolicitationsClick} className={isActive(routesPath.solicitations)}>
              <CommentsIcon />
              <TabName>Solicitações</TabName>
              {solicitationsCount > 0 && (<NotificationsCount>{solicitationsCount}</NotificationsCount>)}
            </ProfileTabItem>
            {!isFreelance && (
              <ProfileTabItem onClick={handleDashboardClick} className={isActive(routesPath.dashboard)}>
                <ChartSimpleIcon />
                <TabName>Painel</TabName>
              </ProfileTabItem>
            )}
            {showNotificationTab && (
              <ProfileTabItem onClick={handleNotificationsClick} className={isActive(routesPath.notifications)}>
                <BellIcon />
                <TabName>Avisos</TabName>
                {notificationsCount > 0 && (<NotificationsCount>{notificationsCount}</NotificationsCount>)}
              </ProfileTabItem>
            )}
          </ProfileTab>
        </>
      )}
      <Route
        {...rest}
        render={({ location }) => {
          return isLogged ? (
            <>
              {children}
              <Footer privateRoute />
            </>
          ) : (
            <Redirect to={{ pathname: '/login', state: { from: location } }} />
          )
        }}
      />
    </>
  )
}

export default PrivateRoute
